import React from 'react';
import withIcon from '../utilities/withIcon';

const IconPencilBox = () => {
  return (
    <g>
      <path d="m1.052 3.004 6.199.01a.75.75 0 0 1 .1 1.493l-.103.007L1.5 4.505V14.5h10.004V8.758a.75.75 0 0 1 .649-.743l.102-.007a.75.75 0 0 1 .743.648l.007.102v6.192c0 .541-.41.987-.936 1.044l-.114.006H1.05a1.05 1.05 0 0 1-1.044-.936L0 14.95V4.054c0-.54.41-.986.936-1.043l.116-.007zM13.656.22l2.124 2.124a.751.751 0 0 1 0 1.062l-6.27 6.27a.751.751 0 0 1-.424.212l-2.479.354a.751.751 0 0 1-.85-.85l.355-2.478a.751.751 0 0 1 .212-.424l6.27-6.27a.751.751 0 0 1 1.062 0zM11.31 3.626 7.563 7.374l-.177 1.24 1.239-.178 3.747-3.748-1.062-1.062zm1.814-1.813-.752.751 1.062 1.062.752-.75-1.062-1.063z" />
    </g>
  );
};

export default withIcon(IconPencilBox);
